<template>
  <a
    :href="section.link"
    class="link"
    :aria-label="section.title"
  >
    <v-lazy-image
      :src="section.icon.source"
      :alt="section.icon.alt"
      width="24"
      height="24"
    />
  </a>
</template>

<script>
  import VLazyImage from 'v-lazy-image'

  export default {
    components: {
      VLazyImage
    },
    props: {
      section: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';

  .link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
  }
</style>
